<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'>数据存储</i></el-breadcrumb-item>
                <el-breadcrumb-item>数据详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            
            <el-container style='border: 1px solid #eee'>
                <el-aside width='250px' style='background-color: rgb(238, 241, 246)'>
                    <el-menu @select='handleMenuSelect'>
                        <el-submenu index='1-2'>
                            <template slot='title'>数据存储</template>
                            <el-menu-item index='createClass'>创建Class</el-menu-item>
                            <div class='schema-menu-scroll'>
                                <el-menu-item v-if='computeShowClass(item)' v-for='(item, index) in schemaList'
                                              :index='`schema-${item.objectId}`'
                                              :class='{ "schema-menu-item-active": currentActiveSchemaName === item.objectId }'
                                              :key='index'>{{ item.objectId }}
                                </el-menu-item>
                            </div>
                            <el-divider>用户</el-divider>
                            <el-menu-item v-for='(item, index) in internalClassList.user' :index='`schema-${item.name}`'
                                          :key='index'>{{ item.name }}
                            </el-menu-item>
                        </el-submenu>
                        
                        <el-submenu index='1-3'>
                            <template slot='title'>服务设置</template>
                            <el-menu-item index='settings'>设置</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-main>
                    <router-view :key='$route.fullPath' />
                </el-main>
            </el-container>
            
            <el-dialog title='创建Class' :close-on-click-modal='true' :close-on-press-escape='true' :show-close='false'
                       :visible.sync='openCreateClass' width='40%'>
                <el-form label-position='top'>
                    <el-form-item label='Class名称'>
                        <el-input v-model='createSchemaInfo.className' size='mini' />
                    </el-form-item>
                    
                    <el-form-item label='Class访问权限'>
                        <class-acl :app-id='queryParams.appId'
                                   :show-button-group='false'
                                   @getAccessInfo='handleGetCLPInfo'
                                   :all-access-info='createSchemaAccessInfo'
                                   :show-authenticated-user-setting='true' />
                    </el-form-item>
                    
                    <el-form-item label='默认ACL权限'>
                        <class-acl :app-id='queryParams.appId'
                                   :show-button-group='false'
                                   :key='new Date().getTime()'
                                   @getAccessInfo='handleGetDefaultACL'
                                   :all-access-info='createSchemaDefaultACL'
                                   :show-data-creator='true'
                                   :show-authenticated-user-setting='false' />
                    </el-form-item>
                </el-form>
                
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='handleCreateSchema'>保 存</el-button>
                    <el-button @click='handleCancelCreate'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog class='schema-search-dialog'
                       title='搜索Class'
                       :visible.sync='openSchemaSearch'
                       width='600px'
                       top='18vh'
                       :close-on-click-modal='true'
                       @close='handleCloseSchemaSearch'>
                <el-input ref='schemaSearchInput'
                          v-model='schemaSearchKeyword'
                          prefix-icon='el-icon-search'
                          clearable
                          @keydown.native='handleSchemaSearchInputKeydown'
                          placeholder='输入Class名称快速跳转' />
                <div ref='schemaSearchResult' class='schema-search-result'>
                    <div v-for='(item, index) in filteredSchemaSearchList'
                         :key='item.key'
                         ref='schemaSearchResultItem'
                         :class='["schema-search-result-item", { "schema-search-result-item-active": index === schemaSearchActiveIndex }]'
                         @click='handleSchemaSearchSelect(item.schemaName)'>
                        <div class='schema-search-result-content'>
                            <div class='schema-search-result-main'>
                                <span class='schema-search-result-name'>{{ item.schemaName }}</span>
                                <span :class='["schema-search-tag", `schema-search-tag-${item.matchType}`]'>
                                    {{ item.matchTypeName }}
                                </span>
                            </div>
                            <div v-if='item.matchText' class='schema-search-result-desc'>{{ item.matchText }}</div>
                        </div>
                        <i class='el-icon-arrow-right'></i>
                    </div>
                    <div v-if='!schemaSearchKeyword' class='schema-search-placeholder'>输入关键词后展示匹配的Class</div>
                    <div v-if='schemaSearchKeyword && filteredSchemaSearchList.length === 0'
                         class='schema-search-placeholder'>未找到匹配的Class
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { message } from '@/utils/message';
import { trackEventApi } from '@api/Track/trackEvent';
import { projectInfoApi } from '@api/ProjectInfo';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import bus from '@/components/common/bus';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import ClassEdit from '@/components/component/storage/ClassEdit.vue';
import ClassAcl from '@/components/component/storage/ClassAcl.vue';
import { packageACLInfo } from '@/utils/storage';

export default {
    name: 'User',
    components: {
        ClassAcl,
        ClassEdit,
        VueJsonPretty
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                appId: undefined
            },
            
            trackDataList: [],
            trackEventList: [],
            currentTrackData: {},
            eventMap: new Map,
            mapTrackerNum: 1,
            projectInfoList: [],
            
            schemaList: [],
            openSchemaSearch: false,
            schemaSearchKeyword: '',
            schemaSearchActiveIndex: -1,
            openCreateClass: false,
            createSchemaInfo: {},
            createSchemaAccessInfo: {
                ADD_FIELD: {
                    allowAll: true
                },
                CREATE: {
                    allowAll: true
                },
                UPDATE: {
                    allowAll: true
                },
                DELETE: {
                    allowAll: true
                },
                QUERY: {
                    allowAll: true
                },
                QUERY_BY_OBJECT_ID: {
                    allowAll: true
                }
            },
            createSchemaDefaultACL: {
                read: {
                    allowAll: true
                },
                write: {
                    allowAll: true
                }
            },
            
            defaultCreateSchemaAccessInfo: {
                ADD_FIELD: {
                    allowAll: true
                },
                CREATE: {
                    allowAll: true
                },
                UPDATE: {
                    allowAll: true
                },
                DELETE: {
                    allowAll: true
                },
                QUERY: {
                    allowAll: true
                },
                QUERY_BY_OBJECT_ID: {
                    allowAll: true
                }
            },
            defaultCreateSchemaDefaultACL: {
                read: {
                    allowAll: true
                },
                write: {
                    allowAll: true
                }
            },
            internalClassList: {
                user: [
                    {
                        label: '_User',
                        value: '_internal_User',
                        name: '_User'
                    },
                    {
                        label: '_Role',
                        value: '_internal_Role',
                        name: '_Role'
                    }
                ]
            }
        };
    },
    computed: {
        currentActiveSchemaName() {
            let params = this.$route.params || {};
            if (params.className) {
                return params.className;
            }
            if (params.schemaName) {
                return params.schemaName;
            }
            
            let matchResult = this.$route.path.match(/\/data\/([^/]+)/);
            if (!matchResult) {
                return '';
            }
            return decodeURIComponent(matchResult[1]);
        },
        filteredSchemaSearchList() {
            let keyword = this.schemaSearchKeyword.trim().toLowerCase();
            if (!keyword) {
                return [];
            }
            let resultList = [];
            this.schemaList.forEach(schema => {
                let schemaName = schema.objectId || '';
                if (schemaName.toLowerCase().indexOf(keyword) !== -1) {
                    resultList.push({
                        key: `${schemaName}-class`,
                        schemaName: schemaName,
                        matchType: 'class',
                        matchTypeName: 'Class',
                        matchText: ''
                    });
                }
                
                let fieldOption = schema.fieldOption || {};
                Object.keys(fieldOption).forEach(fieldName => {
                    let fieldInfo = fieldOption[fieldName] || {};
                    let description = fieldInfo.description || '';
                    
                    if (fieldName.toLowerCase().indexOf(keyword) !== -1) {
                        resultList.push({
                            key: `${schemaName}-field-${fieldName}`,
                            schemaName: schemaName,
                            matchType: 'field',
                            matchTypeName: '字段',
                            matchText: fieldName
                        });
                    }
                    
                    if (description && description.toLowerCase().indexOf(keyword) !== -1) {
                        resultList.push({
                            key: `${schemaName}-description-${fieldName}`,
                            schemaName: schemaName,
                            matchType: 'description',
                            matchTypeName: '注释',
                            matchText: `${fieldName}: ${description}`
                        });
                    }
                });
            });
            return resultList;
        },
        computeShowClass() {
            return t => {
                let className = t.objectId;
                let concat = this.internalClassList.user.map(t => t.name).concat();
                return !concat.includes(className);
            };
        },
        computeEventName() {
            return (data) => {
                let event = this.eventMap.get(parseInt(data.eventId));
                if (!event) {
                    return '未知';
                } else {
                    return event.eventName;
                }
            };
        },
        computeUserAccount() {
            return (data) => {
                // let user = this.adminUserMap.get(data.createUserId)
                // if (!user) {
                //     return '未知'
                // }else {
                //     return user.nickName
                // }
            };
        }
    },
    watch: {
        filteredSchemaSearchList() {
            this.schemaSearchActiveIndex = this.filteredSchemaSearchList.length > 0 ? 0 : -1;
        }
    },
    created() {
        this.setInitValue();
        this.initData();
        // 监听eventBus
        bus.$on('queriedTrackProjectAppId', t => {
            this.queryParams.projectAppId = t;
            this.queryTrackEvent(t);
        });
        bus.$on('queriedTrackEventId', t => {
            this.queryParams.eventId = t;
        });
    },
    mounted() {
        window.addEventListener('keydown', this.handleSchemaSearchShortcut);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleSchemaSearchShortcut);
    },
    methods: {
        handleSchemaSearchShortcut(event) {
            if ((event.ctrlKey || event.metaKey) && event.key && event.key.toLowerCase() === 'f') {
                event.preventDefault();
                this.openSchemaSearch = true;
                this.$nextTick(() => {
                    if (this.$refs.schemaSearchInput) {
                        this.$refs.schemaSearchInput.focus();
                    }
                });
            }
        },
        handleCloseSchemaSearch() {
            this.schemaSearchKeyword = '';
            this.schemaSearchActiveIndex = -1;
        },
        handleSchemaSearchSelect(schemaName) {
            this.openSchemaSearch = false;
            this.schemaSearchKeyword = '';
            this.schemaSearchActiveIndex = -1;
            this.$router.push(`/storage-info/${this.queryParams.appId}/data/${schemaName}`);
        },
        handleSchemaSearchInputKeydown(event) {
            let resultLength = this.filteredSchemaSearchList.length;
            if (!resultLength) {
                return;
            }
            
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                this.schemaSearchActiveIndex = (this.schemaSearchActiveIndex + 1) % resultLength;
                this.scrollSchemaSearchActiveItemIntoView();
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                this.schemaSearchActiveIndex = (this.schemaSearchActiveIndex - 1 + resultLength) % resultLength;
                this.scrollSchemaSearchActiveItemIntoView();
            } else if (event.key === 'Enter' && this.schemaSearchActiveIndex >= 0) {
                event.preventDefault();
                this.handleSchemaSearchSelect(this.filteredSchemaSearchList[this.schemaSearchActiveIndex].schemaName);
            }
        },
        scrollSchemaSearchActiveItemIntoView() {
            this.$nextTick(() => {
                let resultBox = this.$refs.schemaSearchResult;
                let resultItems = this.$refs.schemaSearchResultItem;
                if (!resultBox || !resultItems || this.schemaSearchActiveIndex < 0) {
                    return;
                }
                
                let activeItem = Array.isArray(resultItems) ? resultItems[this.schemaSearchActiveIndex] : resultItems;
                if (!activeItem) {
                    return;
                }
                
                let itemTop = activeItem.offsetTop;
                let itemBottom = itemTop + activeItem.offsetHeight;
                let visibleTop = resultBox.scrollTop;
                let visibleBottom = visibleTop + resultBox.clientHeight;
                
                if (itemTop < visibleTop) {
                    resultBox.scrollTop = itemTop;
                } else if (itemBottom > visibleBottom) {
                    resultBox.scrollTop = itemBottom - resultBox.clientHeight;
                }
            });
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.eventMap = new Map;
            this.trackEventList = [];
            this.projectInfoList = [];
            
            projectInfoApi.query({ pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result;
                }
            });
        },
        getList() {
            this.loading = true;
            
            storageSchemaApi.queryAllSchema(this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    this.schemaList = (result.data.results || []).sort((a, b) => a.objectId.localeCompare(b.objectId, 'en', { sensitivity: 'base' }));
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        resetQueryPage() {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentDataInfo = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件信息';
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.eventName + '"的数据项？').then(function() {
                return;
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    message.success(result.message);
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        async handleProjectSelectChange(projectAppId) {
            if (!projectAppId) {
                message.error('请选择项目!');
            }
            // 根据appId查询事件
            trackEventApi.queryTrackEvent({ projectAppId: projectAppId, pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                    
                    if (this.trackEventList.length === 0) {
                        message.error('当前项目无任何埋点事件!');
                    } else {
                        if (this.queryParams.projectAppId) {
                            bus.$emit('selectedTrackProjectAppId', this.queryParams.projectAppId);
                        }
                    }
                }
            });
        },
        async queryTrackEvent(projectAppId) {
            if (!projectAppId) {
                return;
            }
            // 根据appId查询事件
            trackEventApi.queryTrackEvent({ projectAppId: projectAppId, pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                }
            });
        },
        handleMenuSelect(index, indexPath) {
            if (index === 'createClass') {
                this.openCreateClass = true;
                return;
            }
            if (index.startsWith('schema')) {
                let indexArr = index.split('-');
                let schemaName = indexArr[1];
                this.$router.push(`/storage-info/${this.queryParams.appId}/data/${schemaName}`);
            } else {
                this.$router.push(`/storage-info/${this.queryParams.appId}/${index}`);
            }
        },
        
        setInitValue() {
            this.queryParams.appId = undefined;
            if (this.$route.params.appId && this.$route.params.appId.indexOf('undefined') === -1) {
                this.queryParams.appId = this.$route.params.appId;
            }
            if (!this.queryParams.appId) {
                message.error('请选择应用!');
                this.$router.push(`/storage-application`);
                return;
            }
            this.getList();
        },
        handleGetCLPInfo(accessInfo) {
            this.createSchemaInfo.classLevelPermission = accessInfo;
        },
        async handleGetDefaultACL(accessInfo) {
            let aclInfo = await packageACLInfo(accessInfo);
            this.createSchemaInfo.metadata = {
                default_acp: aclInfo
            };
        },
        handleCreateSchema() {
            let className = this.createSchemaInfo.className;
            if (!className) {
                message.error('Class名称不能为空!');
                return;
            }
            storageSchemaApi.createSchema(className, this.createSchemaInfo, this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    this.openCreateClass = false;
                    message.success(result.message);
                    this.createSchemaInfo = {};
                    this.getList();
                    this.$router.push(`/storage-info/${this.queryParams.appId}/data/${className}`);
                }
            });
        },
        handleCancelCreate() {
            this.openCreateClass = false;
            this.createSchemaInfo = {};
            this.createSchemaDefaultACL = this.defaultCreateSchemaDefaultACL;
            this.createSchemaAccessInfo = this.defaultCreateSchemaAccessInfo;
        }
    }
};
</script>

<style scoped>
.schema-menu-scroll {
    max-height: calc(100vh - 330px);
    min-height: 120px;
    overflow-y: auto;
    overflow-x: hidden;
}

.schema-menu-item-active {
    color: #409eff;
    background-color: #ecf5ff;
    font-weight: 500;
}

.schema-search-dialog /deep/ .el-dialog {
    border-radius: 6px;
}

.schema-search-dialog /deep/ .el-dialog__header {
    padding: 18px 20px 10px;
}

.schema-search-dialog /deep/ .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
}

.schema-search-dialog /deep/ .el-dialog__body {
    padding: 10px 20px 18px;
}

.schema-search-result {
    max-height: 300px;
    min-height: 84px;
    margin-top: 12px;
    overflow-y: auto;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #fff;
}

.schema-search-result-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 46px;
    padding: 8px 12px;
    color: #303133;
    cursor: pointer;
}

.schema-search-result-item + .schema-search-result-item {
    border-top: 1px solid #f2f6fc;
}

.schema-search-result-item:hover {
    background-color: #f5f7fa;
}

.schema-search-result-item-active,
.schema-search-result-item-active:hover {
    background-color: #ecf5ff;
}

.schema-search-result-name {
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.schema-search-result-content {
    min-width: 0;
    flex: 1;
}

.schema-search-result-main {
    display: flex;
    align-items: center;
    min-width: 0;
}

.schema-search-result-desc {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.schema-search-tag {
    flex-shrink: 0;
    margin-left: 8px;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 12px;
    line-height: 18px;
}

.schema-search-tag-class {
    color: #409eff;
    background-color: #ecf5ff;
}

.schema-search-tag-field {
    color: #67c23a;
    background-color: #f0f9eb;
}

.schema-search-tag-description {
    color: #e6a23c;
    background-color: #fdf6ec;
}

.schema-search-result-item .el-icon-arrow-right {
    margin-left: 12px;
    color: #c0c4cc;
}

.schema-search-placeholder {
    padding: 28px 12px;
    color: #909399;
    text-align: center;
}
</style>
